export const SET_SIDEBAR_ITEMS = 'SET_SIDEBAR_ITEMS'

export default function user(state = [], action) {
  switch (action.type) {
    case SET_SIDEBAR_ITEMS: {
      return [].concat(action.sidebar)
    }
    default: {
      return state
    }
  }
}
